var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Document component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDocument extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.97678 2.60498C4.76176 2.60498 4.55553 2.6904 4.40348 2.84245C4.25144 2.9945 4.16602 3.20072 4.16602 3.41575V20.5842C4.16602 20.7992 4.25144 21.0055 4.40348 21.1575C4.55553 21.3096 4.76176 21.395 4.97678 21.395H19.0237C19.2387 21.395 19.445 21.3096 19.597 21.1575C19.7491 21.0055 19.8345 20.7992 19.8345 20.5842V9.96949L12.47 2.60498H4.97678ZM3.34282 1.78179C3.77618 1.34844 4.36393 1.10498 4.97678 1.10498H12.7806C12.9795 1.10498 13.1703 1.184 13.311 1.32465L21.1148 9.1285C21.2555 9.26915 21.3345 9.45991 21.3345 9.65883V20.5842C21.3345 21.1971 21.091 21.7848 20.6577 22.2182C20.2243 22.6515 19.6366 22.895 19.0237 22.895H4.97678C4.36393 22.895 3.77618 22.6515 3.34282 22.2182C2.90947 21.7848 2.66602 21.1971 2.66602 20.5842V3.41575C2.66602 2.8029 2.90947 2.21514 3.34282 1.78179Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDocument.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocument.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocument.prototype, "size", void 0);
if (customElements.get('cat-icon-document') === undefined) {
    customElements.define('cat-icon-document', BlocksIconDocument);
}
